module.exports = __webpack_public_path__ + "static/media/ve.46affed8.svg";